import React from 'react';
import { CardSection } from '../../../../CardInputs/CardsStyledComponents';
import {
  Label,
  TextMedium,
} from '../../../../../styles/GlobalStyledComponents';
import { pricesHelper } from '../../../../../utils/paymentsHelper';
import {
  AmountInputWrapper,
  CardAmountSection,
  IconEuro,
  TextAmountInput,
  TextError,
} from './AmountCardStyledComponents';
import { DebtResponse } from '../../../../../interfaces/Debt';

interface CustomPaymentSectionProps {
  quantity: string;
  handleAmountInput: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handleKeyDown: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  handleOnWheel: (e: React.WheelEvent<HTMLInputElement>) => void;
  amountNotValid: boolean;
  debtResult: DebtResponse | undefined;
  totalDebtAmount: number;
  lastPayment?: number;
  isPaymentPlan?: boolean;
}

const CustomPaymentSection: React.FC<CustomPaymentSectionProps> = ({
  quantity,
  handleAmountInput,
  handleKeyDown,
  handleOnWheel,
  amountNotValid,
  debtResult,
  lastPayment,
  totalDebtAmount,
  isPaymentPlan,
}) => {
/*
//Lógica para insertar el último pago como valor por defecto en el input de cantidad
  useEffect(() => {
    const quantityValue = parseFloat(quantity.replace(',', '.')) || 0;
    if (lastPayment && quantityValue === 0 /* && lastPayment >= debtResult!.min_payment_amount) {
      handleAmountInput({
        target: { value: lastPayment.toString() },
      } as React.ChangeEvent<HTMLInputElement>);
    }
  }, []);
*/
  return (
    <CardAmountSection id="co-custom-payment-amount-section">
      <CardSection id="co-custom-card-section">
        <TextMedium fontSize={14} lineHeight={20}>
          {isPaymentPlan
            ? 'Introduce el importe de la cuota correspondiente o lo que deseas abonar y elige la forma de pago '
            : 'Introduce el importe que deseas abonar y elige la forma de pago'}
        </TextMedium>
      </CardSection>
      <AmountInputWrapper id="co-custom-amount-input-wrapper">
        <TextAmountInput
          value={quantity}
          id="co-custom-amount-input"
          type="number"
          name="amount"
          pattern="[0-9]*"
          inputMode="numeric"
          onChange={handleAmountInput}
          onKeyDown={handleKeyDown}
          onWheel={handleOnWheel}
          placeholder={'0,00'}
          autoComplete="off"
          min="0"
        />
        <IconEuro />
      </AmountInputWrapper>

      {amountNotValid && quantity !== '0,00' && (
        <TextError fontSize={11} font-weight={100}>
          El importe amortizado debe de estar comprendido entre{' '}
          {pricesHelper(debtResult!.min_payment_amount)} € y{' '}
          {pricesHelper(totalDebtAmount)} €
        </TextError>
      )}
      <Label htmlFor="amount-input"></Label>
    </CardAmountSection>
  );
};

export default CustomPaymentSection;
